let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gmfK3")).then(() => parcelRequire('bgYxE'));